module.exports = __webpack_public_path__ + "img/ski.be89373b.svg";